/**
 * Created by Marcus Zhao on 8/25/2022.
 * Description: SignatureEffects
 * Get contact information from email signature.
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { SignatureActionTypes } from '../actions/signature.actions';
import { ContactService } from '@tamalelibs/services/contact.service';

@Injectable()
export class SignatureEffects {
    constructor(
        private _actions$: Actions,
        private _contactService: ContactService
    ) { }

    getSignatureEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(SignatureActionTypes.GET_SIGNATURE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => {
            return this._contactService.getContactFromEmailSignature(payload).pipe(
                map(res => {
                    return {
                        type: SignatureActionTypes.GET_SIGNATURE_DATA_SUCCESS,
                        payload: res
                    };
                }),
                catchError(err => {
                    return of({
                        type: SignatureActionTypes.GET_SIGNATURE_DATA_FAILED,
                        payload: err
                    });
                })
            );
        })
    ));
}
